import Vue from 'vue'
import VueRouter from 'vue-router'
import LayoutVue from "@/layout/index.vue"
import store from "@/store"

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Layout',
    component: LayoutVue,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      meta: {
        title: '首页',
        requireAuth: false
      },
      component: () => import('@/views/home/index.vue')
    }, {
      path: 'competitionGuide',
      name: 'competitionGuide',
      meta: {
        title: '竞赛指南',
        requireAuth: false
      },
      component: () => import('@/views/competitionGuide/index.vue')
    }, {
      path: 'workDisplay',
      name: 'workDisplay',
      meta: {
        title: '作品展示',
        requireAuth: false
      },
      component: () => import('@/views/workDisplay/index.vue')
    }, {
      path: 'workDisplay/detail/:id',
      name: 'workDisplayDetail',
      meta: {
        activePath: '/workDisplay',
        title: '作品展示详情',
        requireAuth: false
      },
      component: () => import('@/views/workDisplay/detail.vue')
    }, 
    // {
    //   path: 'listOfWinners',
    //   name: 'listOfWinners',
    //   meta: {
    //     title: '获奖名单',
    //     requireAuth: false
    //   },
    //   component: () => import('@/views/listOfWinners/index.vue')
    // }, 
    {
      path: 'needRegister',
      name: 'needRegister',
      meta: {
        title: '我要报名',
        requireAuth: true,
        roleAuth: [1]
      },
      component: () => import('@/views/needRegister/index.vue')
    }, {
      path: 'expertReview',
      name: 'expertReview',
      meta: {
        title: '进入专家评审',
        requireAuth: true,
        roleAuth: [2]
      },
      component: () => import('@/views/expertReview/index.vue')
    }, {
      path: 'expertReview/detail/:id',
      name: 'expertReview',
      meta: {
        activePath: '/expertReview',
        title: '评审详情',
        requireAuth: true,
        roleAuth: [2]
      },
      component: () => import('@/views/expertReview/detail.vue')
    }
    ]
  }, {
    path: '/pdfPreview',
    name: 'pdfPreview',
    meta: {
      title: '文件预览',
      requireAuth: false
    },
    component: () => import('@/views/workDisplay/pdf-preview.vue')
  }
]
const router = new VueRouter({
  routes,
  scrollBehavior: () => ({ y: 0, smooth: true }),
  mode: 'history'
})

// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push;
let routerReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}
// replace
VueRouter.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch(err => err)
}


export default router
